import AbstractHttpService from "./AbstractHttpService";
import { GetChannelsResponse } from "../../interfaces/twitch-helix/GetChannelsResponse";

class TwitchHelixApiService extends AbstractHttpService {
  getChannelInfo(channelId: string): Promise<GetChannelsResponse> {
    return this.http
      .get(`channels?broadcaster_id=${channelId}`)
      .then(this.resolve)
      .then(({ json }) => json as GetChannelsResponse)
      .catch(this.reject);
  }
}

export default TwitchHelixApiService;
